module.exports = __webpack_public_path__ + "static/flyer-afc771134858e425e9cfaf29ccb79b2d.pdf";